export default {"src":"/_next/static/media/ic_left_white.85698bb1.svg","height":352,"width":192,"blurWidth":0,"blurHeight":0};